import EstablishmentsDataView from "./EstablishmentsDataView";
import SydFilterProvider from "src/components/Common/UI/SydFilter/SydFilterContext";
import SydFilterView from "src/components/Common/UI/SydFilter/SydFilterView";
import SearchEstablishment from "./SearchEstablishment";

const defaultFilterData: IEstablishmentSearchForm = {
  sapCode: "",
  unID: "",
  description: "",
  deleted: "",
  placeID: ""
}

const Establishments = () => {
  return (
    <SydFilterProvider
      defaultFilterData={defaultFilterData}
    >
      <SydFilterView
        title="Αναζήτηση Καταστήματος"
      >
        <SearchEstablishment />
      </SydFilterView>

      <EstablishmentsDataView />
    </SydFilterProvider>
  )
}
export default Establishments;

